import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AlertTriangle, ShieldCheck } from "lucide-react";
import { verifyPayment } from "@/payments";
import { inr } from "@/pricing";

export default function PaymentReturn({ setCart }) {
  const [params] = useSearchParams();
  const [state, setState] = useState({ loading: true });
  const done = useRef(false);
  const orderId = params.get("order_id");
  useEffect(() => {
    if (done.current) return;
    if (!orderId) return setState({ error: "This payment link is missing an order number." });
    done.current = true;
    verifyPayment(orderId)
      .then((o) => {
        if (o.payment_status === "paid") setCart([]);
        setState({ order: o });
      })
      .catch((e) => setState({ error: e.response?.data?.detail || "We couldn't confirm your payment yet." }));
  }, [orderId, setCart]);
  const o = state.order;
  const paid = o?.payment_status === "paid";
  return (
    <main className="confirmation" data-testid="payment-return">
      <div className="confirm-icon">{paid || state.loading ? <ShieldCheck /> : <AlertTriangle />}</div>
      {orderId && <p className="eyebrow red">ORDER {orderId}</p>}
      {state.loading ? (
        <h1>Confirming payment…</h1>
      ) : state.error && !o ? (
        <>
          <h1>
            We couldn’t find
            <br />
            <i>that payment.</i>
          </h1>
          <p data-testid="payment-return-failed">
            {state.error.replace(/\.?$/, ".")} If you were charged, contact support with your order number and we’ll sort it out.
          </p>
        </>
      ) : paid ? (
        <>
          <h1>
            Payment
            <br />
            <i>confirmed.</i>
          </h1>
          <p data-testid="confirmation-paid">
            Thank you. We received {inr(o.total_inr)} and will email {o.customer?.email} when your order ships. Keep your order number{" "}
            <b>{o.order_id}</b> to <Link to="/track-order">track your order</Link>.
          </p>
        </>
      ) : (
        <>
          <h1>
            Payment
            <br />
            <i>not completed.</i>
          </h1>
          <p data-testid="payment-return-failed">
            Your payment didn’t go through, so you haven’t been charged for this order. You can return to your cart and try again.
          </p>
        </>
      )}
      <Link to={paid ? "/" : "/cart"} className="btn btn-red" data-testid="payment-return-continue">
        {paid ? "Continue shopping" : "Back to cart"}
      </Link>
    </main>
  );
}
